import React, { useState } from "react";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
import "../../../../style/MyAccount-ticket/universal-line-vertical.scss";
import { HiOutlineArrowRight, HiOutlineTicket, HiQrcode } from "react-icons/hi";
import format from "date-fns/format";
import ModalComponent from "../../../../features/ModalComponent";
import QrCodeModal from "../../../../features/QRcode";
import SingleExercise from "./singleExercise";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import SelectPassBar from "./selectPassBar";
import SelectPassModalFooter from "./selectPassModalFooter";
import { useTranslation } from "react-i18next";

interface IProps {
  ticket: Ticket;
  index: number;
  getSelect: () => void;
  changeDeafultView: (value: number) => void;
}
const SelectPassMobile: React.FC<IProps> = ({ ticket, getSelect, index, changeDeafultView }: IProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [assignedList, setAssignedList] = useState(false);
  const allowReservationByPassOnFitnessPlan = useSelector(
    (state: State) => state.config.configuration.allowReservationByPassOnFitnessPlan
  );


  return (
    <React.Fragment>
      {ticket.passtype === 2 && ticket.ticket === false && (
        <div className="line-vertical flex-column">
          <div className="line-vertical-head flex-start-center">
            <HiOutlineTicket className="big-icon" />
            <b>{ticket.name}</b>
          </div>

          <div className="line-vertical-horizontal-line"></div>
          {/*  CONTENT */}
          <div className="line-vertical-content">
            <div className="line-vertical-content-arg">
              <HiOutlineArrowRight className="icon" />
              <b>
                {t("wazny_od")}: {format(ticket.validfrom, "dd.MM.yyyy")}r.
              </b>
            </div>

            <div className="line-vertical-content-arg">
              <HiOutlineArrowRight className="icon" />
              <b>
                {t("wazny_do")}: {format(ticket.validto, "dd.MM.yyyy")}r.
              </b>
            </div>

            <div className="line-vertical-content-arg">
              <HiOutlineArrowRight className="icon" />


              {ticket.entrances - ticket.exercises.length > 1000 ? (<b>{t("pozostalo")}: bez limitu wejść  {t("wejsc")}</b>) : (<b> {t("pozostalo")}: {ticket.entrances - ticket.exercises.length} {t("wejsc")}</b>)}

            </div>
          </div>
          {/*  CONTENT */}
          <div className="line-vertical-buttons">
            <button
              onClick={() => changeDeafultView(index)}
              className="button padding-medium medium button-fill-background-main full-button"
            >
              {t("pokaz_terminy")}
            </button>

            <button
              onClick={() => {
                setOpen(!open);
                window.parent.postMessage("scrollMid::", "*");
              }}
              className="button padding-medium medium button-fill-main full-button"
            >
              {t("pokaz_kod_qr")}
              <HiQrcode className="icon" />
            </button>
          </div>
        </div>
      )}

      {open && (
        <ModalComponent
          footer={false}
          open={open}
          closeModal={() => setOpen(false)}
          title={t("kod_qr")}
          onAccept={() => setOpen(false)}
        >
          <QrCodeModal trhId={ticket.trhId} name={ticket.name} />
          <button
            onClick={() => setOpen(!open)}
            className="button big padding-medium button-fill-second  center-button"
          >
            {t("gotowe_schowaj")}
          </button>
        </ModalComponent>
      )}

      {assignedList && (
        <ModalComponent
          footer={false}
          open={assignedList}
          closeModal={() => setAssignedList(false)}
          title={t("najblizsze_rezerwacje")}
          onAccept={() => setAssignedList(false)}
        >
          <React.Fragment>
            {/* <SelectPassBar ticket={ticket} /> */}

       
              {ticket.exercises[0] && (
                <div>
                  {ticket.exercises.map((exercise, index) => (
                    <div key={index}>
                      <SingleExercise exercise={exercise} getSelect={getSelect} />
                    </div>
                  ))}
                </div>
              )}
        
            {allowReservationByPassOnFitnessPlan && <SelectPassModalFooter ticket={ticket} />}
          </React.Fragment>
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

export default SelectPassMobile;
